import { isFlagEnabled } from "js/utilities";
import { default as ReleasingManagePayment } from "./manage-payment";
import DeprecatedManagePayment from "./DeprecatedManagePayment";

export default function ManagePayment() {
  return isFlagEnabled("ENABLE_RECURRING_PAYMENTS") ? (
    <ReleasingManagePayment />
  ) : (
    <DeprecatedManagePayment />
  );
}
